import { render, staticRenderFns } from "./vendedor.vue?vue&type=template&id=3f0e4e57"
import script from "./vendedor.vue?vue&type=script&lang=js"
export * from "./vendedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports